//Links constant
// export const DASHBOARD_LINK = '/editor/';
// export const EDITOR_LINK = '/editor/';
// export const HEADING_LINK = '/editor/details/';
export const DASHBOARD_LINK = '';
export const EDITOR_LINK = '/editor/';
export const EDITOR_ALL_INONE_LINK = '/editor/allinone/';
export const HEADING_LINK = '/editor/details/';
export const WORKHISTORY_LINK = '/editor/work-history/';
export const EDUCATION_LINK = '/editor/education/';
export const SKILLS_LINK = '/editor/skills/';
export const SUMMARY_LINK = '/editor/summary/';
export const FINALIZE_LINK = '/editor/finalize/';
export const ACCOMPLISHMENTS_LINK = '/editor/accomplishments/'
export const AFFILIATIONS_LINK = '/editor/affiliations/'
export const ADDITIONAL_INFO_LINK = '/editor/additional-information/'
export const ADDITIONAL_SECTIONS_LINK = '/editor/additional-sections/'
export const SOFTWARE_LINK = '/editor/software/'
export const LANGUAGE_LINK = '/editor/languages/'
export const REFERENCE_LINK = '/editor/references/'
export const CERTIFICATIONS_LINK = '/editor/certifications/'
export const INTERESTS_LINK = '/editor/interests/'
export const FINAL_RESUME = '/templates/'
export const RESUMES_LINK = '/editor/resumes/'
export const REARRANGE_LINK = '/editor/rearrange/'
export const RESUME_LINK = '/rlink/:id'
export const LOGIN_LINK = '/login/';
export const LOGIN_PROGRESS_LINK = '/login-progress/';
export const LOGOUT_LINK = '/logout/';
export const SIGNUP_LINK = '/signup/';
export const FORGET_LINK = '/forget-password/';
export const FORGOT_LINK = '/forgot-password/';
export const RESET_LINK = '/resetpswd/';
export const RESET_PASSWORD = '/reset-password/';
export const CHOOSE_COLOR = '/choose-template/';
export const CUSTOM_SECTION_LINK = '/editor/customsection/'
export const VOLUNTEER_INFO_LINK = '/editor/volunteer/'
export const WORKHISTORY_TIPS_LINK = '/editor/work-history-tips/'
export const EDUCATION_TIPS_LINK = '/editor/education-tips/'
export const SKILL_TIPS_LINK = '/editor/skill-tips/'
export const SUMMARY_TIPS_LINK = '/editor/summary-tips/'
export const EDITOR_PAGES = [ADDITIONAL_SECTIONS_LINK, EDITOR_ALL_INONE_LINK, WORKHISTORY_LINK, EDUCATION_LINK, SKILLS_LINK, SUMMARY_LINK, FINALIZE_LINK, ACCOMPLISHMENTS_LINK, ADDITIONAL_INFO_LINK, SOFTWARE_LINK, LANGUAGE_LINK, CERTIFICATIONS_LINK, INTERESTS_LINK, FINAL_RESUME, AFFILIATIONS_LINK, CUSTOM_SECTION_LINK, HEADING_LINK, VOLUNTEER_INFO_LINK, REARRANGE_LINK,WORKHISTORY_TIPS_LINK, SUMMARY_TIPS_LINK, SKILL_TIPS_LINK, EDUCATION_TIPS_LINK]
export const CREATE_RESUME = '/create-resume/';
export const UPLOAD_RESUME = '/upload-resume/';
export const CHOOSE_EDITOR = '/choose-editor/';
export const MEMBERSHIP = '/membership/';
export const CHECKOUT = '/checkout/';
export const MY_ACCOUNT = '/my-account/';
export const MEMBERSHIP_CANCELLATION = '/membership/cancellation/'
export const EDIT_PROFILE = '/edit-profile/';
export const CHANGE_PASSWORD = '/change-password/';
export const UPDATE_PAYMENT_INFO = '/update-payment-info/';
export const INVOICES = '/invoices/';
export const PAYMENT_METHODS = '/payment-methods/';
export const COVERLETTER_LINK = '/build-cover-letter/';
export const BUILD_COVERLETTER = '/build-coverletter/';
export const COVERLETTER_CHOOSE_TEMPLATE = '/build-cover-letter/choose-template/';
export const COVERLETTER_CUSTOMIZE = '/build-cover-letter/customize/';
export const COVERLETTER_JOBDETAILS = '/build-cover-letter/job-details/';
export const COVERLETTER_STRENGTH = '/build-cover-letter/strengths/';
export const COVERLETTER_SKILLS = '/build-cover-letter/skills/';
export const COVERLETTER_EXPERIENCE = '/build-cover-letter/experience/';
export const COVERLETTER_EXP_WORKHISTORY = '/build-cover-letter/experience/work-history/';
export const COVERLETTER_WORKSTYLE = '/build-cover-letter/work-style/';
export const COVERLETTER_FINALIZE = '/build-cover-letter/finalize/';
export const COVERLETTER_PERSONALIZE = '/build-cover-letter/personalize/';
export const COVERLETTER_LOGIN = '/build-cover-letter/sign-up/';
export const COVERLETTER_SHARE_LINK = '/cl/:id'
export const COVERLETTER_SHAREPDF_LINK = '/cl-link/:id'
export const COVERLETTER_LANDINGPAGE = '/build-cover-letter/'
export const REFRESH_LINK = '/refresh/';
export const COVERLETTER_PAGES = [COVERLETTER_CHOOSE_TEMPLATE,COVERLETTER_CUSTOMIZE, COVERLETTER_JOBDETAILS,COVERLETTER_STRENGTH,COVERLETTER_SKILLS,COVERLETTER_EXPERIENCE,COVERLETTER_EXP_WORKHISTORY,COVERLETTER_WORKSTYLE,COVERLETTER_FINALIZE,COVERLETTER_PERSONALIZE,]
export const COVERLETTER_QA_PAGES = [ COVERLETTER_JOBDETAILS,COVERLETTER_STRENGTH,COVERLETTER_SKILLS,COVERLETTER_EXP_WORKHISTORY,COVERLETTER_WORKSTYLE]
export const NEXT_WORKHISTORY_LABEL = 'Continue';
export const NEXT_EDUCATION_LABEL = 'Continue';
export const NEXT_SKILLS_LABEL = 'Continue';
export const NEXT_SUMMARY_LABEL = 'Continue';
export const NEXT_FINALIZE_LABEL = 'Continue';
export const NEXT_LABEL = 'Continue';
export const MY_DASHBOARD_LINK = '/membership-account/';
export const RECAPTCHA_SITE_KEY = '6LexUzEqAAAAANuhN3cnNGnh7gvMiTCEli2QPbN6';
export const UNDO_LIMIT = 100;
export const REDO_LIMIT = 100;
export const PAID_SERVICES = true;
export const ACCOUNT_SYNC = 900; // in seconds
export const COUPON_SERVICES = false;
export const CRYPTO_SECRET_KEY = '#`)R$+,ap5?16`<11Q(bk,RzBc71XsE:yL8^|ky`P XpAw<h(puEBR@J^6^J&^(7R'

export const HOME_URL = CUSTOM_HOME_URL;
export const APP_DOMAIN = APP_URL;
export const SITE_DOMAIN = SITE_URL;
export const COOKIE_DOMAIN = RB_COOKIE_DOMAIN;
export const SENTRY_REPO_URL = RB_SENTRY_REPO_URL;
export const SEARCH_PARAMS = RB_SEARCH_PARAMS;

export const IMAGE_FOLDER_URL = `${SITE_DOMAIN}/wp-content/themes/resumebuilder/builder/src/assets/images`;
export const APP_IMAGE_FOLDER_URL = `${APP_DOMAIN}/assets/images`;
export const ADDITONAL_PREDEFINE_SECTIONS = {
  additional_information: { struct: { content: '', new: true,
  grid: {
    row_1: {name:'', address: '',address_line_2:'', start_date:'',end_date:'',content:'', url:'', open:true },
  }, }, name: 'Custom Section' },
  accomplishments: { name: 'Accomplishments', url: ACCOMPLISHMENTS_LINK, struct: { 
    content: '', 
    new: true,
    grid: {
      row_1: { award_name: '', awarded_by: '', awarded_date:'',content:'',open:true },
    }, } },
  affiliations: { name: 'Affiliations', url: AFFILIATIONS_LINK, struct: { content: '', new: true } },
  volunteer: { name: 'Volunteering', url: VOLUNTEER_INFO_LINK, struct: { 
    content: '', 
    new: true,
    grid: {
      row_1: { activity_name: '', address: '',address_line_2:'', start_date:'',end_date:'',content:'',open:true },
    },
  } },
  certifications: {
    name: 'Certifications', url: CERTIFICATIONS_LINK, struct: {
      set: {
        row_1: { date: '', name: '',institution:'' ,content:'', url:'', open:true  },
      }, new: true,
    }
  },
  languages: { name: 'Languages', url: LANGUAGE_LINK, struct: { 
    content: '', 
    new: true,
    grid: {
      row_1: { expertise_level: 5, name: '',open:true },
    },
   } },
  //references: { name: 'References', url: REFERENCE_LINK, struct: { content: '', new: true } },
  references: {
    name: 'References', 
    url: REFERENCE_LINK, 
    struct: {
      grid: {
        row_1: { name: '', reference_reletionship: '', start_date: '', end_date: '', content: '', open: true },
      }, 
      new: true,
    }
  },
  interests: { name: 'Interests', url: INTERESTS_LINK, struct: { content: '', new: true } },
  softwares: { name: 'Software', url: SOFTWARE_LINK, struct: { 
    content: '', 
    new: true,
    grid: {
      row_1: { expertise_level: 5, name: '',open:true },
    },
   }  },
}
export const TPLS_COLOR = [ // do not add any new color code here,
  { id: 'color-variant-one', name: 'Purple', color_code: '#7D7D7D' },
  { id: 'color-variant-two', name: 'Blue', color_code: '#00008B' },
  { id: 'color-variant-three', name: 'Orange', color_code: '#8C0000' },
  { id: 'color-variant-four', name: 'Green', color_code: '#005000' },
  // { id: 'color-dark-grey-variant', name: 'Grey' },
  { id: 'color-variant-five', name: 'Dark Pink', color_code: '#17A9E4' },
  { id: 'color-variant-six', name: 'Light Green', color_code: '#FF7F7F' },
  { id: 'color-variant-seven', name: 'Light Pink', color_code: '#22A699' },
  { id: 'color-variant-eight', name: 'Navy Blue', color_code: '#FFCC00' },
  { id: 'color-variant-nine', name: 'Off White', color_code: '#f5f1ee' },
];
export const OLD_COLOR_CODES = {
  'color-variant-orange' : 'color-variant-one',
  'color-variant-blue' : 'color-variant-two',
  'color-variant-pink' : 'color-variant-three',
  'color-dark-grey-variant' : 'color-variant-four',
  'color-variant-green' : 'color-variant-five',
  'color-variant-purple' : 'color-variant-six',
  'color-variant-pink-two' : 'color-variant-seven',
  'color-variant-green-two' : 'color-variant-eight',
  'color-navy-blue-variant' : 'color-variant-nine'
}
export const TPLTS = [
  { id: "template-thirty-one", name: "Template Thirty One", color: 'color-variant-thirty-one', resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-thirty-two", name: "Template Thirty Two", color: 'color-variant-thirty-two', resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-thirty-three", name: "Template Thirty Three", color: 'color-variant-thirty-three', resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-thirty-four", name: "Template Thirty Four", color: 'color-variant-thirty-four', resume: true, resume_listing_priority: 100, profile_picture: true },

  { id: "template-thirty-five", name: "Template Thirty Five", color: 'color-variant-thirty-five', resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-thirty-six", name: "Template Thirty Six", color: 'color-variant-thirty-six', resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-thirty-seven", name: "Template Thirty Seven", color: 'color-variant-thirty-seven', resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-thirty-eight", name: "Template Thirty Eight", color: 'color-variant-thirty-eight', resume: true, resume_listing_priority: 100, profile_picture: true },

  { id: "template-thirty-nine", name: "Template Thirty Nine", color: 'color-variant-thirty-nine', resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-forty", name: "Template Forty", color: 'color-variant-forty', resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-forty-one", name: "Template Forty One", color: 'color-variant-forty-one', resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-forty-two", name: "Template Forty Two", color: 'color-variant-forty-two', resume: true, resume_listing_priority: 100, profile_picture: true },

  { id: "template-forty-three", name: "Template Forty Three", color: 'color-variant-forty-three', resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-forty-four", name: "Template Forty Four", color: 'color-variant-forty-four', resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-forty-five", name: "Template Forty Five", color: 'color-variant-forty-five', resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-forty-six", name: "Template Forty Six", color: 'color-variant-forty-six', resume: true, resume_listing_priority: 100, profile_picture: true },

  { id: "template-forty-seven", name: "Template Forty Seven", color: 'color-variant-forty-seven', resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-forty-eight", name: "Template Forty Eight", color: 'color-variant-forty-eight', resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-forty-nine", name: "Template Forty Nine", color: 'color-variant-forty-nine', resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-fifty", name: "Template Fifty", color: 'color-variant-fifty', resume: true, resume_listing_priority: 100, profile_picture: true },

  { id: "template-fifty-one", name: "Template Fifty One", color: 'color-variant-fifty-one', resume: true, resume_listing_priority:100, profile_picture: true },
  { id: "template-fifty-two", name: "Template Fifty Two", color: 'color-variant-fifty-two', resume: true, resume_listing_priority:100, profile_picture: true },
  { id: "template-fifty-three", name: "Template Fifty Three", color: 'color-variant-fifty-three', resume: true, resume_listing_priority:100, profile_picture: true },
  { id: "template-fifty-four", name: "Template Fifty Four", color: 'color-variant-fifty-four', resume: true, resume_listing_priority:100, profile_picture: true },

  { id: "template-fifty-five", name: "Template Fifty Five", color: 'color-variant-fifty-five', resume: true, resume_listing_priority:100, profile_picture: true },
  { id: "template-fifty-six", name: "Template Fifty Six", color: 'color-variant-fifty-six', resume: true, resume_listing_priority: 100},
  { id: "template-fifty-seven", name: "Template Fifty Seven", color: 'color-variant-fifty-seven', resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-fifty-eight", name: "Template Fifty Eight", color: 'color-variant-fifty-eight', resume: true, resume_listing_priority: 100 },
  
  { id: "template-fifty-nine", name: "Template Fifty Nine", color: 'color-variant-fifty-nine', resume: true, resume_listing_priority: 100 },
  { id: "template-sixty", name: "Template Sixty", color: 'color-variant-sixty', resume: true, resume_listing_priority: 100 },
  { id: "template-sixty-one", name: "Template Sixty One", color: 'color-variant-sixty-one', resume: true, resume_listing_priority: 100 },
  { id: "template-sixty-two", name: "Template Sixty Two", color: 'color-variant-sixty-two', resume: true, resume_listing_priority: 100 },

  { id: "template-sixty-three", name: "Template Sixty Three", color: 'color-variant-sixty-three', resume: true, resume_listing_priority: 100 },
  { id: "template-sixty-four", name: "Template Sixty Four", color: 'color-variant-sixty-four', resume: true, resume_listing_priority: 100, profile_picture: true  },
  { id: "template-sixty-five", name: "Template Sixty Five", color: 'color-variant-sixty-five', resume: true, resume_listing_priority: 100, },
  { id: "template-sixty-six", name: "Template Sixty Six", color: 'color-variant-sixty-six', resume: true, resume_listing_priority: 100 },
  
  { id: "template-sixty-seven", name: "Template Sixty Seven", color: 'color-variant-sixty-seven', resume: true, resume_listing_priority: 100 },
  { id: "template-sixty-eight", name: "Template Sixty Eight", color: 'color-variant-sixty-eight', resume: true, resume_listing_priority: 100 },
  { id: "template-sixty-nine", name: "Template Sixty Nine", color: 'color-variant-sixty-nine', resume: true, resume_listing_priority: 100 },
  { id: "template-seventy", name: "Template Seventy", color: 'color-variant-seventy', resume: true, resume_listing_priority: 100 },

  { id: "template-seventy-one", name: "Template Seventy One", color: 'color-variant-seventy-one', resume: true, resume_listing_priority: 100 },
  { id: "template-seventy-two", name: "Template Seventy Two", color: 'color-variant-seventy-two', resume: true, resume_listing_priority: 100 },
  { id: "template-seventy-three", name: "Template Seventy Three", color: 'color-variant-seventy-three', resume: true, resume_listing_priority: 100 },
  { id: "template-seventy-four", name: "Template Seventy Four", color: 'color-variant-seventy-four', resume: true, resume_listing_priority: 100 },
  
  { id: "template-seventy-five", name: "Template Seventy Five", color: 'color-variant-seventy-five', resume: true, resume_listing_priority: 100 },
  { id: "template-seventy-six", name: "Template Seventy Six", color: 'color-variant-seventy-six', resume: true, resume_listing_priority: 100 },
  { id: "template-seventy-seven", name: "Template Seventy Seven", color: 'color-variant-seventy-seven', resume: true, resume_listing_priority: 100 },

  // Row 1
  // { id: "template-thirty-one", name: "Template Three V3", color: 'color-variant-thirty-one', resume: true, resume_listing_priority: 100, profile_picture: false },
  { id: "template-twelve", name: "Template Twelve", color: "color-variant-eleven", coverletter: true, coverletter_listing_priority: 311, resume: true, resume_listing_priority: 100, profile_picture: false },
  { id: "template-ten-v5", name: "Template Ten V5", color: "color-variant-ten", resume: true, resume_listing_priority: 100, profile_picture: false },
  { id: "template-twenty-three", name: "Template Twenty Three", color: "color-variant-twenty-three", resume: true, resume_listing_priority: 100, coverletter: true, coverletter_listing_priority: 200, profile_picture: true },
  // { id: "template-sixteen-v2", name: "Template Sixteen V2", color: 'color-variant-five', resume: false, resume_listing_priority:100 , coverletter: true, coverletter_listing_priority: 201, profile_picture: true },
  { id: "template-nine-v3", name: "Template Nine V3", color: "color-variant-nine", resume: true, resume_listing_priority: 100, profile_picture: false },

  // Row 2
  { id: "template-fourteen", name: "Template Fourteen", color: "color-variant-six", resume: true, resume_listing_priority: 100, coverletter: true, coverletter_listing_priority: 309, profile_picture: false },
  { id: "template-eighteen", name: "Template Eighteen", color: "color-variant-twelve", resume: true, resume_listing_priority: 100, coverletter: true, coverletter_listing_priority: 305, profile_picture: true },
  { id: "template-seventeen", name: "Template Seventeen", color: "color-variant-eleven", resume: true, resume_listing_priority: 100, coverletter: true, coverletter_listing_priority: 306, profile_picture: true },
  { id: "template-eight", name: "Template Eight", color: "color-variant-eight", resume: true, resume_listing_priority: 100, profile_picture: true },

  // Row 3
  { id: "template-sixteen", name: "Template Sixteen", color: "color-variant-five", resume: true, resume_listing_priority: 100, coverletter: true, coverletter_listing_priority: 308, profile_picture: true },
  { id: "template-ten-v3", name: "Template Ten V3", color: "color-variant-ten", resume: true, resume_listing_priority: 100, profile_picture: false },
  // { id: "template-twenty-one", name: "Template Twenty One", color: 'color-variant-fifteen', profile_picture: true },
  { id: "template-five-v4", name: "Template Five V4", color: "color-variant-five", resume: true, resume_listing_priority: 100, profile_picture: false },
  { id: "template-twenty", name: "Template Twenty", color: "color-variant-ten", resume: true, resume_listing_priority: 100, profile_picture: true },

  // Row 4
  { id: "template-four", name: "Template Four", color: "color-variant-four", resume: true, resume_listing_priority: 100, profile_picture: false },
  { id: "template-seven", name: "Template Seven", color: "color-variant-seven", resume: true, resume_listing_priority: 100, profile_picture: false },
  { id: "template-four-v5", name: "Template Four V5", color: "color-variant-four", resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-five", name: "Template Five", color: "color-variant-five", resume: true, resume_listing_priority: 100, profile_picture: false },

  // Row 5
  { id: "template-fifteen", name: "Template Fifteen", color: "color-variant-ten", resume: true, resume_listing_priority: 100, profile_picture: false },
  { id: "template-eleven", name: "Template Eleven", color: "color-variant-five", coverletter: true, coverletter_listing_priority: 312, resume: true, resume_listing_priority: 100, profile_picture: false },
  { id: "template-twenty-five", name: "Template Twenty Five", color: "color-variant-twenty-five", resume: true, resume_listing_priority: 100, profile_picture: false },
  { id: "template-ten", name: "Template Ten", color: "color-variant-ten", resume: true, resume_listing_priority: 100, profile_picture: false },

  // Row 6
  { id: "template-twenty-four", name: "Template Twenty Four", color: "color-variant-twenty-four", coverletter: true, coverletter_listing_priority: 313, resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-thirteen", name: "Template Thirteen", color: "color-variant-twelve", resume: true, resume_listing_priority: 100, coverletter: true, coverletter_listing_priority: 310, profile_picture: false },
  { id: "template-nineteen", name: "Template Nineteen", color: "color-variant-seven", resume: true, resume_listing_priority: 100, coverletter: true, coverletter_listing_priority: 304, profile_picture: true },
  { id: "template-six", name: "Template Six", color: "color-variant-six", resume: true, resume_listing_priority: 100, profile_picture: false },

  // Row 7
  { id: "template-seven-v3", name: "Template Seven V3", color: "color-variant-seven", resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-eight-v2", name: "Template Eight V2", color: "color-variant-eight", resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-six-v3", name: "Template Six V3", color: "color-variant-six", resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-two-v3", name: "Template Two V3", color: "color-variant-two", resume: true, resume_listing_priority: 100, profile_picture: false },

  // Row 8
  { id: "template-one", name: "Template One", color: "color-variant-one", resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-four-v4", name: "Template Four V4", color: "color-variant-four", resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-three-v5", name: "Template Three V5", color: "color-variant-three", resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-five-v2", name: "Template Five V2", color: "color-variant-five", resume: true, resume_listing_priority: 100, profile_picture: false },

  // Row 9
  { id: "template-three-v4", name: "Template Three V4", color: "color-variant-three", resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-ten-v4", name: "Template Ten V4", color: "color-variant-ten", resume: true, resume_listing_priority: 100, profile_picture: false },
  { id: "template-two", name: "Template Two", color: "color-variant-two", resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-one-v3", name: "Template One V3", color: "color-variant-one", resume: true, resume_listing_priority: 100, profile_picture: true },

  // Row 10
  { id: "template-six-v2", name: "Template Six V2", color: "color-variant-six", resume: true, resume_listing_priority: 100, profile_picture: false },
  { id: "template-two-v2", name: "Template Two V2", color: "color-variant-two", resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-nine-v2", name: "Template Nine V2", color: "color-variant-nine", resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-eight-v3", name: "Template Eight V3", color: "color-variant-eight", resume: true, resume_listing_priority: 100, profile_picture: false },

  // Row 11
  { id: "template-five-v3", name: "Template Five V3", color: "color-variant-five", resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-one-v2", name: "Template One V2", color: "color-variant-one", resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-three", name: "Template Three", color: "color-variant-three", resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-four-v2", name: "Template Four V2", color: "color-variant-four", resume: true, resume_listing_priority: 100, profile_picture: true },

  // Row 12
  { id: "template-three-v2", name: "Template Three V2", color: "color-variant-three", resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-four-v3", name: "Template Four V3", color: "color-variant-four", resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-five-v5", name: "Template Five V5", color: "color-variant-five", resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-ten-v2", name: "Template Ten V2", color: "color-variant-ten", resume: true, resume_listing_priority: 100, profile_picture: false },

  // Row 13
  { id: "template-seven-v2", name: "Template Seven V2", color: "color-variant-seven", resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-nine", name: "Template Nine", color: "color-variant-nine", resume: true, resume_listing_priority: 100, profile_picture: true },
  { id: "template-three-v3", name: "Template Three V3", color: "color-variant-three", resume: true, resume_listing_priority: 100, profile_picture: false },
]
export const BREADCRUMB_LINKS = {
  heading: {
    id: "heading",
    tab_name: "Contact Information",
    link: HEADING_LINK,
    main_title: "What’s the best way for employers to contact you?",
    description: "Include your email and phone number.",
    tooltip: "'Heading Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum',"
  },
  education: {
    id: "education",
    tab_name: "Education",
    link: EDUCATION_LINK,
    main_title: "Tell us about your education",
    description: "Include every school, even if you're still there or didn't graduate.",
    tipspage_heading: "Well done! Now, let's cover your educational background.",
    tooltip: "'educaiton Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum',",
  },
  work_history: {
    id: "work_history",
    tab_name: "Work Experience",
    link: WORKHISTORY_LINK,
    tipspage_heading: "Great progress! Let's highlight your professional achievements.",
    tooltip: "'WORKHISTORY Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum',",
    wh_1: {
      id: "work_history_1",
      tab_name: "Work Experience",
      main_title: "Tell us about your most recent job",
      description: "We’ll start there and work backward.",
    },
    wh_2: {
      id: "work_history_2",
      tab_name: "Work Experience",
      main_title: "What did you do at ABCDE Company as a Sale Associate",
      description:
        "Get help writing your bullet points with the pre-written examples below.",
      predefind_list: [
        {
          title: "Expert Recommendation",
          description:
            "Helped customers locate products and checked store system for merchandise at other sites.",
        },
        {
          title: "Expert Recommendation 2",
          description:
            "Organized racks and shelves to maintain store visual appeal, engage customers and promote specific merchandise.",
        },
        {
          title: "Expert Recommendation 3",
          description:
            "Loaded and unloaded merchandise using ladder and pallet jack.",
        },
      ],
    },
  },
  skills: {
    id: "skills",
    tab_name: "Key Skills",
    link: SKILLS_LINK,
    main_title: "What skills do you want to highlight?",
    description: "Use our expert recommendations below to get started.",
    tipspage_heading: "You're doing great! Now, let's spotlight your most valuable skills.",
    tooltip: "'skills Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum',",
    data: {
      descr: "",
    },
    predefined_list: [
      {
        title: "Microsoft Word",
      },
      {
        title: "Photoshop",
      },
      {
        title: "Illustrator",
      },
      {
        title: "In Design",
      },
    ],
  },
  summary: {
    id: "summary",
    tab_name: "Profile",
    link: SUMMARY_LINK,
    main_title: "Briefly tell us about your background",
    description: "Use our expert recommendations below to get started.",
    tipspage_heading: "You're almost there! Let's wrap it up with your professional summary.",
    tooltip: "'Summary Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum',",
    data: {
      content: "",
    },
    predefined_list: [
      {
        title: "Microsoft Word",
        desc:
          "Highly motivated Sales Associate with extensive customer service and sales experience. Outgoing sales professional with track record of driving increased sales, improving buying experience and elevating company profile with target market. Consistently recognized for sales performance and excellence in customer service.",
      },
      {
        title: "Photoshop",
        desc:
          "Highly motivated Sales Associate with extensive customer service and 1",
      },
      {
        title: "Illustrator",
        desc:
          "Highly motivated Sales Associate with extensive customer service and 2",
      },
      {
        title: "In Design",
        desc:
          "Highly motivated Sales Associate with extensive customer service and  3",
      },
    ],
  },
  finalize: {
    id: "finalize",
    tab_name: "Complete",
    link: FINALIZE_LINK,
    main_title: "The Preview of the Resume",
    description: "The completed resume will be look like as the preview",
    tooltip: "'finalize Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum',",
  },
  additional_sections: {
    id: "additional_sections",
    tab_name: "Aditional Sections",
    link: ADDITIONAL_SECTIONS_LINK,
  },
}
export const DEGREES = [
  'High school diploma',
  'GED',
  'Associate of Art',
  'Associate of Science',
  'Bachelor of Art',
  'Bachelor of Science',
  'BBA',
  'Master of Arts',
  'Master of Science',
  'MBA',
  'MD',
  'JD',
  'Ph.D'
]
export const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const START_YEAR = 1920;

export const STATE_LIST = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'Washington D.C.', 'West Virginia', 'Wisconsin', 'Wyoming'];

export const DEFAULT_SECTION_DISPLAY_ORDER = ['work_history', 'education_history', 'skills'];

export const DEFAULT_SECTION_NAMES = {
  'work_history': 'Enter Your Professional Experience', 'education_history': ' List Your Education', 'skills': 'Showcase Your Key Skills',
  ...(() => {
    let name = {}
    Object.keys(ADDITONAL_PREDEFINE_SECTIONS).forEach((v) => {
      name = { ...name, [v]: ADDITONAL_PREDEFINE_SECTIONS[v].name }
    })
    return name
  })()
}

export const FONT_FAMILIES = [
  { id: '', name: 'Default' },
  { id: 'merriweather', name: 'Merriweather' },
  { id: 'montserrat', name: 'Montserrat' },
  { id: 'raleway', name: 'Raleway' },
  { id: 'roboto', name: 'Roboto' },
  { id: 'ubuntu', name: 'Ubuntu' }
]

export const FONT_SIZES = [
  // { id: '', name: 'Default' },
  { id: 'small', name: 'Small' },
  { id: 'medium', name: 'Medium' },
  { id: 'large', name: 'Large' },
  { id: 'extra-large', name: 'Extra Large' }
]

export const LINE_SPACING = [
  // { id: '', name: 'Default' },
  { id: 'small', name: 'Small' },
  { id: 'medium', name: 'Medium' },
  { id: 'large', name: 'Large' },
  { id: 'extra-large', name: 'Extra Large' }
]

export const HELP_OPTIONS = [
  // { id: 1, name: 'Billing' },
  { id: 2, name: 'Accessing my account' },
  { id: 3, name: 'Technical Assistance' },
  { id: 4, name: 'Other' }
]

export const REACT_APP_SECRET_KEY = "6Lf6ksMUAAAAABT-wJcNnEtK7qcYuOIIN5N9Htyo";
export const REACT_APP_SITE_KEY = "6Lf6ksMUAAAAAKh-PUMPIJlJXC1jQewOjh_D5ES0";

export const SOCIAL_LOGIN_GG_CLIENT_ID = '172441586925-k47b2qiqn17rg0ju8rklt9dq9ao1lg0n.apps.googleusercontent.com';
export const SOCIAL_LOGIN_GG_CLIENT_SECRET = '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';
export const SOCIAL_LOGIN_FB_APP_ID = 1584485932059949;

export const FULLSTORY_ORG_ID = 'o-1NBGEW-na1';

export const STRIPE_PUBLISHABLE_KEY = RB_STRIPE_PUBLISHABLE_KEY;

export const FACEBOOK_META_PIXEL_ID = RB_FACEBOOK_META_PIXEL_ID;

export const REDIRECT_URI = `${APP_URL}/login`;

export const SKILL_LEVEL = ['Beginner', 'Amateur', 'Competent', 'Proficient', 'Expert'];
export const SKIP_CONFIRMATION_BOX_CONTENT = {
  heading: `Think twice before skipping this section`,
  content: "We recommend completing every section to create a strong section. If you skip this part, it won’t be included in your resume, but you can always come back and add it later.",
  confirmButtonText: 'Skip section',
  cancelButtonText: "Complete section"
}
export const SHOW_PROFILE_PICTURE_CONFIRMATION_BOX_CONTENT = {
  heading: `Would you like to disable the profile picture?`,
  content: "If you disable the profile picture, it won't appear on your resume.",
  confirmButtonText: 'Disable',
  cancelButtonText: "I don't want to disable"
}
export const DELETE_CONFIRMATION_BOX_CONTENT = {
  heading: `Confirm`,
  content: "Would you like to delete this summary?",
  confirmButtonText: "Yes",
  cancelButtonText: 'No'
}
export const POPUP_TYPES = {
  section_skip: {
      type: 'confirmbox',
      content: SKIP_CONFIRMATION_BOX_CONTENT,
  },
  row_delete: {
      type: 'confirmbox',
      content: DELETE_CONFIRMATION_BOX_CONTENT,
  },
  delete: {
      type: 'confirmbox',
      content: {
        heading: `Confirm`,
        content: "Are you sure you want to delete?",
        confirmButtonText: "Yes",
        cancelButtonText: 'No'
      }
  },
  share: {
    type: 'sharebox',
    content: {
      title: `Share`,
      heading: `Share a Link to Your Resume`,
      // content: [
      //   "Share this link on social media or copy and paste the URL to send your resume via text, email or to share your resume on your personal website.",
      //   "Copy this private URL"
      // ],
      content: 
        "Share this link on social media or copy and paste the URL to send your resume via text, email or to share your resume on your personal website."
        +" Copy this private URL"
      ,
      copyButtonText: "Copy Link",
      openLinkText: 'Open Link'
    }
  },
  msgbox1: {
    type: 'confirmbox',
    content: {
      heading: "",
      content: "This custom section can only be added once. You can add multiple custom section types to your resume.",
      confirmButtonText: "Proceed to Section",
      cancelButtonText: 'Ok'
    },
  },
  downloadcompletionbox: {
    type: 'confirmbox',
    content: {
      heading: "Don't forget to add a cover letter to go with your resume.",
      content: "Our cover letter tool can help you write the perfect cover letter. Start now!",
      confirmButtonText: "Ok, let's start!",
      cancelButtonText: 'Not yet'
    },
  },
  exit: {
    type: 'confirmbox',
    content: {
      heading: "",
      content: "Are you sure you want to exit?",
      confirmButtonText: "Go to Dashboard",
      cancelButtonText: 'Cancel'
    },
  },
  download: {
    type: "downloadbox",
    content: {
      heading: `Download Resume`,
      content: "",
      confirmButtonText: "Continue",
      cancelButtonText: "Cancel"
    }
  },
  show_profile_picture: {
    type: 'confirmbox',
    content: SHOW_PROFILE_PICTURE_CONFIRMATION_BOX_CONTENT,
  },
  rearrangebox: {
    type: 'rearrangebox',
    content: {
      content: ''
    }
  },
  duplicate: {
    type: 'duplicatebox',
    content: {
      content: ''
    }
  },
  rename: {
    type: 'renamebox',
    content: {
      content: ''
    }
  },
  ai_entity_title: {
    type: 'aientitytitlebox',
    content: {
      content: ''
    }
  },
  alert: {
    type: 'alertbox',
    content: {
      title: "",
      heading: "",
      content: "",
      confirmButtonText: "Ok",
      cancelButtonText: ""
    }
  },
  aiwarning: {
    type: 'alertbox',
    content: {
      title: "Error",
      heading: "Error",
      content: "System is not able to auto generate coverletter. Please try after sometime or write it yourself. We are sorry for inconvenience. ",
      confirmButtonText: "Close",
      cancelButtonText: ""
    }
  },
  wait: {
    type: 'waitingbox',
    content: {
      title: "",
      heading: "",
      content: "Generating your cover letter",
      confirmButtonText: "Ok",
      cancelButtonText: ""
    }
  },
  aiwarning: {
    type: 'confirmbox',
    content: {
      title: "Error",
      heading: "Oops!",
      content: "We're sorry, our system couldn't auto-generate a cover letter. Please try again and contact us for support if the error persists.",
      confirmButtonText: "Regenerate Cover Letter",
      cancelButtonText: "Close"
    }
  },
  cl_content_override: {
    type: 'confirmbox',
    content: {
      title: "Confirm",
      heading: "Overwrite Your Cover Letter?",
      content: "This action will replace your cover letter with new content. Would you like to proceed?",
      confirmButtonText: "Continue",
      cancelButtonText: "Cancel"
    }
  },
  askfor_trustpilot_review: {
    type: 'askforreview',
    content: {
      title: "Thank you for using Resume Templates!",
      heading: "Thank you for using Resume Templates!",
      content: "Check the download folder on your device. ",
      confirmButtonText: "Review us on",
      cancelButtonText: ""
    }
  },
}

export const TOOLTIPS = {
  heading: `<h3>Expert Tips</h3><p>Your resume header should contain essential information, including your name, email, phone number, city, and state for easy reference.</p><ul><li>Add a link to your LinkedIn profile if you have one.</li><li>Only include your street address if it’s required, such as for federal jobs.
  </li><li>Don’t forget to link to your online profile if applicable.</li></ul>`,
  work_history: `<h3>Expert Tips</h3><p>Use your professional experience section to highlight your accomplishments, demonstrate your impact, and show how you contributed to your previous roles. Focus on quantifiable results and action-driven bullet points to make your achievements stand out.</p><ul><li>Start each bullet point with a strong action verb and emphasize your accomplishments, not just duties.</li><li>Quantify your achievements whenever possible (e.g., "increased sales by 20%" or "managed a team of 15").</li><li>Tailor your professional experience to match the job description by including relevant keywords and skills.</li></ul>`,
  education_history: `<h3>Expert Tips</h3><p>Your education section should clearly outline your academic background, especially if it directly relates to the job you're applying for. Highlight degrees, certifications, and any relevant coursework to show your qualifications. If you’re a recent graduate, place this section higher on your resume, but if you have substantial work experience, it can follow your professional experience.</p><ul><li>Include your degree, school name, and graduation date.</li><li>Mention any relevant coursework, academic honors, or projects.</li><li>List certifications related to the position you're applying for.
  </li></ul>`,
  skills: "<h3>Expert Tips</h3><p>The key skills section helps to capture the attention of hiring managers and applicant tracking systems (ATS). Use this area to highlight your most relevant hard and soft skills for the job. Focus on including a mix of technical competencies and interpersonal skills.</p><ul><li>Align your skills with those mentioned in the job posting to pass ATS filters.</li><li>Organize your skills in bullet points to enhance readability.</li><li>Prioritize job-specific skills first, followed by more general, transferable abilities.</li></ul>",
  additional_sections: "<h3>Expert Tips</h3><p>Use additional sections to highlight unique experiences or interests that can set you apart from other candidates. While not essential for every job, including hobbies, publications, or volunteer work can demonstrate well-roundedness, creativity, or industry expertise. Use these sections strategically to showcase qualities or experiences that align with the company culture or the job role. </p><ul><li>Only include hobbies if they are relevant to the role or reflect qualities like leadership, teamwork, or creativity.</li><li>List any professional publications, blogs, or articles you’ve authored that are related to your field.</li><li>Mention any volunteer work or affiliations that showcase your commitment or passion for causes that align with the employer’s values.</li></ul>",
  summary: "<h3>Expert Tips</h3><p>Your resume summary is your elevator pitch — a brief snapshot of your qualifications, strengths, and career achievements. Use this section to summarize the most compelling reasons you’re an ideal fit for the role. It’s especially useful for experienced candidates to position themselves strongly right at the start.</p><ul><li>Include your job title, years of experience, and top skills or specializations.</li><li>Highlight specific achievements or qualifications that set you apart.</li><li>Keep it concise but impactful — aim for 3-4 sentences that grab attention.</li></ul>",
  cover_editor_content: "<h3>Our Advice</h3><p>Your cover letter should feature five main elements: a heading, salutation, introduction, two body paragraphs, and a closing section.</p><ul><li>Quantify your achievements by using numbers to give context to your experience. Share growth percentages, satisfaction ratings, and key performance indicators. </li><li>Explain why you're drawn to the opportunity. Highlight aspects of the role you're well suited for or what you like about the company.</li><li>Align your cover letter with the job description, tailoring your cover letter to mention specifics about the company and draw attention to aspects of your skills and experience that match the employer's needs.</li></ul>"
}
export const TRANSITIONAL_BLOCKS = {
  work_history: `<ul><li>Highlight your achievements by using specific numbers and measurable results.</li><li>Turn everyday tasks into standout accomplishments that demonstrate impact.</li></ul>`,
  education_history: `<ul><li>Include degrees, certifications, licenses, and relevant industry training.</li><li>For recent graduates, emphasize academic projects, honors, and key coursework.</li></ul>`,
  skills: "<ul><li>Use keywords from job postings to optimize for employers and applicant tracking systems.</li><li>Include a balance of hard skills, such as programming, and soft skills, such as leadership.</li></ul>",
  summary: "<ul><li>Craft a brief, high-level overview of your key accomplishments and strengths.</li><li>Mention your job title, years of experience, and top skills.</li></ul>"
}

export const DEFAULT_RB_AI_DATA = [];

export const SECTION_COLOR_CLASS = {
  heading: "blue-line",
  work_history: "red-line",
  education_history: "light-green-line",
  skills: "light-blue-line",
  additional_sections: "orange-line"
};

export const BETATOOLTIP = "<p>We are excited to announce that we have launched the new beta version of our Resume Builder app. For a limited time, we have unlocked all the premium features, providing you with full access to powerful tools that can make your resume truly stand out. The beta version will be available until June 20th, 2023.</p>";

export const SUMMARY_TOOLTIP = "<p>Build your resume using one of the following tools: Our database of suggested phrases written by certified resume writers or our resume builder AI that generates bullet points based on your target role. Alternatively, you can add your own content directly to the resume builder.</p>";
//Template name used in src/components/CreateResumeWithTemplate.jsx also
export const DEFAULT_TEMPLATE_COLOR = {
  'template-one': '#DE8535',
  'template-one-v2': '#DE8535',
  'template-one-v3': '#DE8535',
  'template-two': '#17A9E4',
  'template-two-v2': '#17A9E4',
  'template-two-v3': '#17A9E4',
  'template-three': '#B2436F',
  'template-three-v2': '#B2436F',
  'template-three-v3': '#B2436F',
  'template-three-v4': '#B2436F',
  'template-three-v5': '#B2436F',
  'template-four': '#58585B',
  //Template name used in src/components/CreateResumeWithTemplate.jsx also
  'template-four-v2': '#58585B',
  'template-four-v3': '#58585B',
  'template-four-v4': '#58585B',
  'template-four-v5': '#58585B',
  'template-five': '#98C64D',
  'template-five-v2': '#98C64D',
  'template-five-v3': '#98C64D',
  'template-five-v4': '#98C64D',
  'template-five-v5': '#98C64D',
  'template-six': '#5B509B',
  'template-six-v2': '#5B509B',
  'template-six-v3': '#5B509B',
  'template-seven': '#DD3B7A',
  //Template name used in src/components/CreateResumeWithTemplate.jsx also
  'template-seven-v2': '#DD3B7A',
  'template-seven-v3': '#DD3B7A',
  'template-eight': '#5E8E66',
  'template-eight-v2': '#5E8E66',
  'template-eight-v3': '#5E8E66',
  'template-nine': '#0D183A',
  'template-nine-v2': '#0D183A',
  'template-nine-v3': '#0D183A',
  'template-ten': '#000000',
  'template-ten-v2': '#000000',
  'template-ten-v3': '#000000',
  'template-ten-v4': '#000000',
  'template-ten-v5': '#000000',
  //Template name used in src/components/CreateResumeWithTemplate.jsx also
  'template-eleven': '#98C64D',
  'template-twelve': '#2A64AD',
  'template-thirteen': '#E9932F',
  'template-fourteen': '#5B509B',
  'template-fifteen': '#000000',
  'template-sixteen': '#98c64d',
  'template-sixteen-v2': '#000000',
  'template-seventeen': '#2A64AD',
  'template-eighteen': '#E9932F',
  'template-nineteen': '#DD3B7A',
  'template-twenty': '#000000',
  'template-twenty-one': '#2A2C27',
  'template-twenty-five': '#f5f1ee',
  'template-twenty-three': '#B8F19D',
  'template-twenty-three-v2': '#785F93',
  'template-twenty-four': '#5b509b',
  'template-thirty-one':'#144F5D',
  'template-thirty-two': '#1C4587',
  'template-thirty-three': '#8D7CC2',
  'template-thirty-four': '#144F5D',
  'template-thirty-five': '#073863',
  'template-thirty-six': '#434343',
  'template-thirty-seven': '#741B47',
  'template-thirty-eight': '#144F5D',
  'template-thirty-nine': '#434343',
  'template-forty': '#E06665',
  'template-forty-one': '#0C5395',
  'template-forty-two': '#BF9100',
  'template-forty-three': '#144F5D',
  'template-forty-four': '#434343',
  'template-forty-five': '#674FA7',
  'template-forty-six': '#073863',
  'template-forty-seven': '#434343',
  'template-forty-eight': '#A64D79',
  'template-forty-nine': '#434343',
  'template-fifty': '#0C5395',
  'template-fifty-one': '#434343',
  'template-fifty-two': '#434343',
  'template-fifty-three': '#434343',
  'template-fifty-four': '#434343',
  'template-fifty-five': '#A64D79',
  'template-fifty-six': '#E69137',
  'template-fifty-seven': '#46818F',
  'template-fifty-eight': '#674FA7',
  'template-fifty-nine': '#434343',
  'template-sixty': '#CFE2F3',
  'template-sixty-one': '#46818F',
  'template-sixty-two': '#E06665',
  'template-sixty-three': '#FBE5CD',
  'template-sixty-four': '#434343',
  'template-sixty-five': '#F5F5F5',
  'template-sixty-six': '#434343',
  'template-sixty-seven': '#46818F',
  'template-sixty-eight': '#0E5293',
  'template-sixty-nine': '#666666',
  'template-seventy': '#BC9300',
  'template-seventy-one': '#C7C9F8',
  'template-seventy-two': '#0000008C',
  'template-seventy-three': '#3E85C7',
  'template-seventy-four': '#A6005A',
  'template-seventy-five': '#674E9D',
  'template-seventy-six': '#A81D1D',
  'template-seventy-seven': '#A64D79',
};
export const DEFAULT_COVERLETTER_TEMPLATE_COLOR = {
 
  //Template name used in src/components/CreateResumeWithTemplate.jsx also
  'template-eleven': '#588981',
  'template-twelve': '#4D5279',
  'template-thirteen': '#E4A829',
  'template-fourteen': '#C34C8C',
  'template-sixteen': '#245610',
  'template-seventeen': '#2F497E',
  'template-eighteen': '#BC936D',
  'template-nineteen': '#6B0000',
  'template-twenty-three': '#618553',
  'template-twenty-four': '#543477',
  'template-sixteen-v2': '#000000',
  'template-twenty-three-v2': '#785F93',
};
//color variant name used in src/components/CreateResumeWithTemplate.jsx also
export const DEFAULT_VARIANT_COLOR = {
  'color-variant-one': '#DE8535',
  'color-variant-two': '#17A9E4',
  'color-variant-three': '#B2436F',
  'color-variant-four': '#58585B',
  'color-variant-five': '#98C64D',
  'color-variant-six': '#5B509B',
  'color-variant-seven': '#DD3B7A',
  'color-variant-eight': '#5E8E66',
  'color-variant-nine': '#0D183A',
  'color-variant-ten': '#000000',
  'color-variant-eleven': '#2A64AD',
  'color-variant-twelve': '#E9932F',
  'color-variant-thirteen': '#E9932F',
  //color variant name used in src/components/CreateResumeWithTemplate.jsx also
  'color-variant-fourteen': '#5B509B',
  'color-variant-fifteen': '#000000',
  'color-variant-sixteen': '#98c64d',
  'color-variant-seventeen': '#2A64AD',
  'color-variant-eighteen': '#E9932F',
  'color-variant-nineteen': '#DD3B7A',
  'color-variant-twenty': '#000000',
  'color-variant-twenty-one': '#2A2C27',
  'color-variant-twenty-five': '#a71b24',
  'color-variant-twenty-three': '#385718',
  'color-variant-twenty-four': '#5b509b',
  'color-variant-thirty-one':'#144F5D',
  'color-variant-thirty-two': '#1C4587',
  'color-variant-thirty-three': '#8D7CC2',
  'color-variant-thirty-four': '#144F5D',
  'color-variant-thirty-five': '#073863',
  'color-variant-thirty-six': '#434343',
  'color-variant-thirty-seven': '#741B47',
  'color-variant-thirty-eight': '#144F5D',
  'color-variant-thirty-nine': '#434343',
  'color-variant-forty': '#E06665',
  'color-variant-forty-one': '#BF9100',
  'color-variant-forty-two': '#0C5395',
  'color-variant-forty-three': '#144F5D',
  'color-variant-forty-four': '#434343',
  'color-variant-forty-five': '#674FA7',
  'color-variant-forty-six': '#073863',
  'color-variant-forty-seven': '#434343',
  'color-variant-forty-eight': '#A64D79',
  'color-variant-forty-nine': '#434343',
  'color-variant-fifty': '#0C5395',
  'color-variant-fifty-one': '#434343',
  'color-variant-fifty-two': '#434343',
  'color-variant-fifty-three': '#434343',
  'color-variant-fifty-four': '#434343',
  'color-variant-fifty-five': '#A64D79',
  'color-variant-fifty-six': '#E69137',
  'color-variant-fifty-seven': '#46818F',
  'color-variant-fifty-eight': '#674FA7',
  'color-variant-fifty-nine': '#434343',
  'color-variant-sixty': '#CFE2F3',
  'color-variant-sixty-one': '#46818F',
  'color-variant-sixty-two': '#E06665',
  'color-variant-sixty-three': '#FBE5CD',
  'color-variant-sixty-four': '#434343',
  'color-variant-sixty-five': '#F5F5F5',
  'color-variant-sixty-six': '#434343',
  'color-variant-sixty-seven': '#46818F',
  'color-variant-sixty-eight': '#0E5293',
  'color-variant-sixty-nine': '#666666',
  'color-variant-seventy': '#BC9300',
  'color-variant-seventy-one': '#C7C9F8',
  'color-variant-seventy-two': '#0000008C',
  'color-variant-seventy-three': '#3E85C7',
  'color-variant-seventy-four': '#A6005A',
  'color-variant-seventy-five': '#674E9D',
  'color-variant-seventy-six': '#A81D1D',
  'color-variant-seventy-seven': '#A64D79',
};
//color variant name used in src/components/CreateResumeWithTemplate.jsx also
export const TEMPLATE_IDS = {
  t1v1: {tpl: 'template-one', color: 'color-variant-one'},
  t1v2: {tpl: 'template-one-v2', color: 'color-variant-one'},
  t1v3: {tpl: 'template-one-v3', color: 'color-variant-one'},
  t2v1: {tpl: 'template-two', color: 'color-variant-two'},
  t2v2: {tpl: 'template-two-v2', color: 'color-variant-two'},
  t2v3: {tpl: 'template-two-v3', color: 'color-variant-two'},
  t3v1: {tpl: 'template-three', color: 'color-variant-'},
  t3v2: {tpl: 'template-three-v2', color: 'color-variant-three'},
  t3v3: {tpl: 'template-three-v3', color: 'color-variant-three'},
  t3v4: {tpl: 'template-three-v4', color: 'color-variant-three'},
  t3v5: {tpl: 'template-three-v5', color: 'color-variant-three'},
  t4v1: {tpl: 'template-four', color: 'color-variant-four'},
  t4v2: {tpl: 'template-four-v2', color: 'color-variant-four'},
  t4v3: {tpl: 'template-four-v3', color: 'color-variant-four'},
  t4v4: {tpl: 'template-four-v4', color: 'color-variant-four'},
  t4v5: {tpl: 'template-four-v5', color: 'color-variant-four'},
  t5v1: {tpl: 'template-five', color: 'color-variant-five'},
  t5v2: {tpl: 'template-five-v2', color: 'color-variant-five'},
  t5v3: {tpl: 'template-five-v3', color: 'color-variant-five'},
  t5v4: {tpl: 'template-five-v4', color: 'color-variant-five'},
  t5v5: {tpl: 'template-five-v5', color: 'color-variant-five'},
  t6v1: {tpl: 'template-six', color: 'color-variant-six'},
  t6v2: {tpl: 'template-six-v2', color: 'color-variant-six'},
  t6v3: {tpl: 'template-six-v3', color: 'color-variant-six'},
  t7v1: {tpl: 'template-seven', color: 'color-variant-seven'},
  t7v2: {tpl: 'template-seven-v2', color: 'color-variant-seven'},
  t7v3: {tpl: 'template-seven-v3', color: 'color-variant-seven'},
  t8v1: {tpl: 'template-eight', color: 'color-variant-eight'},
  t8v2: {tpl: 'template-eight-v2', color: 'color-variant-eight'},
  t8v3: {tpl: 'template-eight-v3', color: 'color-variant-eight'},
  t9v1: {tpl: 'template-nine', color: 'color-variant-nine'},
  t9v2: {tpl: 'template-nine-v2', color: 'color-variant-nine'},
  t9v3: {tpl: 'template-nine-v3', color: 'color-variant-nine'},
  t10v1: {tpl: 'template-ten', color: 'color-variant-ten'},
  t10v2: {tpl: 'template-ten-v2', color: 'color-variant-ten'},
  t10v3: {tpl: 'template-ten-v3', color: 'color-variant-ten'},
  t10v4: {tpl: 'template-ten-v4', color: 'color-variant-ten'},
  t10v5: {tpl: 'template-ten-v5', color: 'color-variant-ten'},
  t11: {tpl: 'template-eleven', color: 'color-variant-eleven'},
  t12: {tpl: 'template-twelve', color: 'color-variant-eleven'},
  t13: {tpl: 'template-thirteen', color: 'color-variant-twelve'},
  t14: {tpl: 'template-fourteen', color: 'color-variant-fourteen'},
  t15: {tpl: 'template-fifteen', color: 'color-variant-fifteen'},
  t16: {tpl: 'template-sixteen', color: 'color-variant-sixteen'},
  t16v2: {tpl: 'template-sixteen-v2', color: 'color-variant-sixteen'},
  t17: {tpl: 'template-seventeen', color: 'color-variant-seventeen'},
  t18: {tpl: 'template-eighteen', color: 'color-variant-eighteen'},
  t19: {tpl: 'template-nineteen', color: 'color-variant-nineteen'},
  t20: {tpl: 'template-twenty', color: 'color-variant-twenty'},
  t21: {tpl: 'template-twenty-one', color: 'color-variant-twenty-one'},
  t22: {tpl: 'template-twenty-five', color: 'color-variant-twenty-five'},
  t23: {tpl: 'template-twenty-three', color: 'color-variant-twenty-three'},
  t23v2: {tpl: 'template-twenty-three-v2', color: 'color-variant-twenty-three'},
  t24: {tpl: 'template-twenty-four', color: 'color-variant-twenty-four'},
  t31:{tpl:'template-thirty-one',color:'color-variant-thirty-one'},
  t32: {tpl: 'template-thirty-two', color: 'color-variant-thirty-two'},
  t33: {tpl: 'template-thirty-three', color: 'color-variant-thirty-three'},
  t34: {tpl: 'template-thirty-four', color: 'color-variant-thirty-four'},
  t35: {tpl: 'template-thirty-five', color: 'color-variant-thirty-five'},
  t36: {tpl: 'template-thirty-six', color: 'color-variant-thirty-six'},
  t37: {tpl: 'template-thirty-seven', color: 'color-variant-thirty-seven'},
  t38: {tpl: 'template-thirty-eight', color: 'color-variant-thirty-eight'},
  t39: {tpl: 'template-thirty-nine', color: 'color-variant-thirty-nine'},
  t40: {tpl: 'template-forty', color: 'color-variant-forty'},
  t41: {tpl: 'template-forty-one', color: 'color-variant-forty-one'},
  t42: {tpl: 'template-forty-two', color: 'color-variant-forty-two'},
  t43: {tpl: 'template-forty-three', color: 'color-variant-forty-three'},
  t44: {tpl: 'template-forty-four', color: 'color-variant-forty-four'},
  t45: {tpl: 'template-forty-five', color: 'color-variant-forty-five'},
  t46: {tpl: 'template-forty-six', color: 'color-variant-forty-six'},
  t47: {tpl: 'template-forty-seven', color: 'color-variant-forty-seven'},
  t48: {tpl: 'template-forty-eight', color: 'color-variant-forty-eight'},
  t49: {tpl: 'template-forty-nine', color: 'color-variant-forty-nine'},
  t50: {tpl: 'template-fifty', color: 'color-variant-fifty'},
  t51: {tpl: 'template-fifty-one', color: 'color-variant-fifty-one'},
  t52: {tpl: 'template-fifty-two', color: 'color-variant-fifty-two'},
  t53: {tpl: 'template-fifty-three', color: 'color-variant-fifty-three'},
  t54: {tpl: 'template-fifty-four', color: 'color-variant-fifty-four'},
  t55: {tpl: 'template-fifty-five', color: 'color-variant-fifty-five'},
  t56: {tpl: 'template-fifty-six', color: 'color-variant-fifty-six'},
  t57: {tpl: 'template-fifty-seven', color: 'color-variant-fifty-seven'},
  t58: {tpl: 'template-fifty-eight', color: 'color-variant-fifty-eight'},
  t59: {tpl: 'template-fifty-nine', color: 'color-variant-fifty-nine'},
  t60: {tpl: 'template-sixty', color: 'color-variant-sixty'},
  t61: {tpl: 'template-sixty-one', color: 'color-variant-sixty-one'},
  t62: {tpl: 'template-sixty-two', color: 'color-variant-sixty-two'},
  t63: {tpl: 'template-sixty-three', color: 'color-variant-sixty-three'},
  t64: {tpl: 'template-sixty-four', color: 'color-variant-sixty-four'},
  t65: {tpl: 'template-sixty-five', color: 'color-variant-sixty-five'},
  t66: {tpl: 'template-sixty-six', color: 'color-variant-sixty-six'},
  t67: {tpl: 'template-sixty-seven', color: 'color-variant-sixty-seven'},
  t68: {tpl: 'template-sixty-eight', color: 'color-variant-sixty-eight'},
  t69: {tpl: 'template-sixty-nine', color: 'color-variant-sixty-nine'},
  t70: {tpl: 'template-seventy', color: 'color-variant-seventy'},
  t71: {tpl: 'template-seventy-one', color: 'color-variant-seventy-one'},
  t72: {tpl: 'template-seventy-two', color: 'color-variant-seventy-two'},
  t73: {tpl: 'template-seventy-three', color: 'color-variant-seventy-three'},
  t74: {tpl: 'template-seventy-four', color: 'color-variant-seventy-four'},
  t75: {tpl: 'template-seventy-five', color: 'color-variant-seventy-five'},
  t76: {tpl: 'template-seventy-six', color: 'color-variant-seventy-six'},
  t77: {tpl: 'template-seventy-seven', color: 'color-variant-seventy-seven'},
}
export const DEFAULT_PLAN = {
  name: "",
  username: "",
  email: "",
  plan:{
      trial_plan: false,
      status: "",
      is_basic: "",
      name: "",
      description: "",
      expiryDate: ""
  }
}

export const PAYMENT_METHOD_TYPES = ['card', 'googlePay', 'applePay']; 

export const DISABLED_RATING_TEMPLATES = [
  'template-one',
  'template-two-v3',
  'template-three-v3',
  'template-four',
  'template-four-v5',
  'template-five',
  'template-five-v5',
  'template-six',
  'template-seven',
  'template-eight-v2',
  'template-nine-v2',
  'template-ten',
  'template-ten-v2',
  'template-ten-v3',
  'template-ten-v4',
  'template-ten-v5',
  'template-twenty-three',
  'template-twenty-five',
  'template-thirty-one',
  'template-thirty-two',
  'template-thirty-three',
  'template-thirty-four',
  'template-thirty-five',
  'template-thirty-six',
  'template-thirty-seven',
  'template-thirty-eight',
  'template-thirty-nine',
  'template-forty',
  'template-forty-one',
  'template-forty-two',
  'template-forty-three',
  'template-forty-four',
  'template-forty-five',
  'template-forty-six',
  'template-forty-seven',
  'template-forty-eight',
  'template-forty-nine',
  'template-fifty',
  'template-fifty-one',
  'template-fifty-two',
  'template-fifty-three',
  'template-fifty-four',
  'template-fifty-five',
  'template-fifty-six',
  'template-fifty-seven',
  'template-fifty-eight',
  'template-fifty-nine',
  'template-sixty',
  'template-sixty-one',
  'template-sixty-two',
  'template-sixty-three',
  'template-sixty-four',
  'template-sixty-five',
  'template-sixty-six',
  'template-sixty-seven',
  'template-sixty-eight',
  'template-sixty-nine',
  'template-seventy',
  'template-seventy-one',
  'template-seventy-two',
  'template-seventy-three',
  'template-seventy-four',
  'template-seventy-five',
  'template-seventy-six',
  'template-seventy-seven',
];

export const DAY_TO_UPDATE_YEAR = 5;
export const TEMPLATES_IN_V2 = [
  'template-thirty-one',
  'template-thirty-two',
  'template-thirty-three',
  'template-thirty-four',
  'template-thirty-five',
  'template-thirty-six',
  'template-thirty-seven',
  'template-thirty-eight',
  'template-thirty-nine',
  'template-forty',
  'template-forty-one',
  'template-forty-two',
  'template-forty-three',
  'template-forty-four',
  'template-forty-five',
  'template-forty-six',
  'template-forty-seven',
  'template-forty-eight',
  'template-forty-nine',
  'template-fifty',
  'template-fifty-one',
  'template-fifty-two',
  'template-fifty-three',
  'template-fifty-four',
  'template-fifty-five',
  'template-fifty-six',
  'template-fifty-seven',
  'template-fifty-eight',
  'template-fifty-nine',
  'template-sixty',
  'template-sixty-one',
  'template-sixty-two',
  'template-sixty-three',
  'template-sixty-four',
  'template-sixty-five',
  'template-sixty-six',
  'template-sixty-seven',
  'template-sixty-eight',
  'template-sixty-nine',
  'template-seventy',
  'template-seventy-one',
  'template-seventy-two',
  'template-seventy-three',
  'template-seventy-four',
  'template-seventy-five',
  'template-seventy-six',
  'template-seventy-seven',
]
